import { NavLink } from 'react-router-dom'

interface NavMenuProps {
	onLinkClick?: () => void
}

const NavMenu = ({ onLinkClick }: NavMenuProps) => {
	const getLinkClass = ({ isActive }: { isActive: boolean }) =>
		`font-heading text-base font-semibold tracking-wide transition-all py-1 ${
			isActive
				? 'text-brand-blue border-b-2 border-brand-blue'
				: 'text-slate-800 hover:text-brand-blue'
		}`

	return (
		<nav className='flex flex-col md:flex-row gap-6 md:gap-10 items-start md:items-center w-full md:w-auto'>
			<NavLink to='/' end className={getLinkClass} onClick={onLinkClick}>
				Home
			</NavLink>
			<NavLink to='/about' className={getLinkClass} onClick={onLinkClick}>
				About
			</NavLink>
			<NavLink to='/products' className={getLinkClass} onClick={onLinkClick}>
				Products
			</NavLink>
			<NavLink to='/contact' className={getLinkClass} onClick={onLinkClick}>
				Contact
			</NavLink>
		</nav>
	)
}

export default NavMenu
